module.exports = __webpack_public_path__ + "58be2cc5c65aebcefcc369cec922d3c7.jpg";